<div class="wrapper">
    <div class="message" *ngIf="data.message">
        {{ data.message }}
    </div>
    <div *ngIf="isArray(data.meta);then array else string"></div>
    <ng-template #array>
        <div class="meta">
           <ul>
                <li *ngFor="let m of data.meta">{{ m.field }}: {{ m.message }}</li>
            </ul>
        </div>
    </ng-template>
    <ng-template #string>
        <div class="meta">
            {{ data.meta }}
        </div>
    </ng-template>
</div>